import { addDays, startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachDayOfInterval, isBefore } from 'date-fns';
import { Navigate } from 'react-big-calendar';

import type { Weekday } from '../../../../lib';

export const getMonthRange = (date: Date, startOfWeekDay: Weekday): { date: Date; isPlaceholder: boolean }[][] => {
	const start = startOfWeek(startOfMonth(date), { weekStartsOn: startOfWeekDay });
	const end = endOfWeek(endOfMonth(date), { weekStartsOn: startOfWeekDay });
	const range: { date: Date; isPlaceholder: boolean }[][] = [];

	let current = start;
	while (current <= end) {
		const week: { date: Date; isPlaceholder: boolean }[] = [];
		for (let i = 0; i < 7; i++) {
			week.push({
				date: current,
				isPlaceholder: current < startOfMonth(date) || current > endOfMonth(date),
			});
			current = addDays(current, 1);
		}
		range.push(week);
	}

	return range;
};

export const navigateMonth = (date: Date, action: string, { localizer }): Date => {
	switch (action) {
		case Navigate.PREVIOUS:
			return localizer.add(date, -1, 'month');
		case Navigate.NEXT:
			return localizer.add(date, 1, 'month');
		default:
			return date;
	}
};

export const getTitle = (date: Date, { localizer }): string => {
	return localizer.format(date, 'MMMM yyyy');
};

// Helper function to get all days between start and end of an event
export const getEventDays = (event) =>
	!isBefore(event.end, event.start) ? eachDayOfInterval({ start: event.start, end: event.end }) : [];
